<template>
    <div class="Sac-Principal">
        <PageTitle icon="fa fa-phone" main="Importação de função e funcionários"
            sub="GLOBUS / JB" />
        <div class="Folha-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Importar função" active><FolImportacaoFuncao/></b-tab>                                                                                                                                            
                    <b-tab title="Importar funcionários"><FolImportacaoFuncionario/></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import FolImportacaoFuncao from '../folhapagamento/FolImportacaoFuncao'
import FolImportacaoFuncionario from '../folhapagamento/FolImportacaoFuncionario'
export default {
    name: 'SacPrincipal',    
    components: { PageTitle, FolImportacaoFuncao,FolImportacaoFuncionario}
    
}
</script>

<style>

</style>






